export const formatNumber = (number) => {
  return `$${parseFloat(number.toFixed(2)).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    useGrouping: true,
  })}`
}
